module.exports = __webpack_public_path__ + "img/SO.2f2ed5a4.svg";